<script>
import NotificationsCollection from '../components/notifications/NotificationsCollection.vue';

export default {
  components: { NotificationsCollection },
};
</script>